export default __webpack_public_path__ + "static/media/2.0b1f72a7.jpg";